<template>
    <div>
    <span :class="color">עם </span>
    <router-link :class="color"
    :to="{name: 'teacherPage', params:{tid: teacherId}}">
    {{teacher.name}}</router-link>
    </div>
</template>

<script>
export default {
  name: `TeacherTag`,
  props: {
    teacher: Object,
    className: String
  },
  computed: {
    teacherId() {
      if (this.teacher.id !== ``) {
        return this.teacher.id;
      }
      return 1;
    },

    color() {
      if (this.className) {
        return this.className;
      }
      return `crimson`;
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  display: inline-block;
}
</style>
